import {dd,store,app} from 'systems/imports'

import BaseApi from 'api/BaseApi'
import { normalize, schema, Array } from 'normalizr';

/**
 */
class SchoolCode extends BaseApi{
  static getClassName(){ return 'SchoolCode' }

  /**
   */
  static schoolCodeActivation(input){
    return app.make("axios").post(`v1/organization/school-code-activation`,input)
      .then(({data}) =>{
        return data.data
      })
      .catch(error => {
        let erroRes =  error.response.data.error || "server_error"
        throw Object.assign(new Error(erroRes), { name: erroRes, statusCode: error.response.data.status });
      })
  }

}
export default SchoolCode



// WEBPACK FOOTER //
// ./src/api/SchoolCode.js